// import PropTypes from 'prop-types'
// import React, { useEffect, useState } from "react"

// import { connect } from "react-redux"

// import { Link } from "react-router-dom"
// import { useWindowSize } from 'react-use';

// // Reactstrap
// import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"

// // Import menuDropdown
// import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown"
// import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"

// // import megamenuImg from "../../assets/images/megamenu-img.png"
// import ios from "../../assets/images/hts_logo.png";
// import lmsLogo from "../../assets/images/lmsLogo.png";
// import tataLogo from "../../assets/images/Tata.png";
// import companyLogo from "../../assets/images/companyLogo.jpeg";
// import lmsLogo2 from "../../assets/images/lmsLogo2.png";
// import ios1 from "../../assets/images/1.png";
// import logoLightPng from "../../assets/images/logo-light.png"
// import logoDark from "../../assets/images/logo-dark.png"

// //i18n
// import { withTranslation } from "react-i18next"

// // Redux Store
// import {
//   showRightSidebarAction,
//   toggleLeftmenu,
//   changeSidebarType,
// } from "../../store/actions"

// // Helper function to fetch user data
// import { getSingleUser } from "helpers/user_helper"

// //css import
// import classes from "./Header.module.css";
// import { IMAGE_FETCH } from 'helpers/url_helper';

// // Import profile image
// import user1 from "../../assets/images/profile_icon.png";

// const Header = props => {
//   const [search, setsearch] = useState(false)
//   const [createmenu, setCreateMenu] = useState(false)
//   const [logoHeight, setLogoHeight] = useState(80);
//   const { width } = useWindowSize();
//   const [organizationId, setOrganizationId] = useState(null);
//   const [userName, setUserName] = useState("");
//   const [menu, setMenu] = useState(false);
//   const [userProfile, setUserProfile] = useState(null);
//   const [userRole, setUserRole] = useState("");
//   const [userDepot, setUserDepot] = useState("");
//   const [userEmail, setUserEmail] = useState("");
//   const [userMobile, setUserMobile] = useState("");
//   const [userId, setUserId] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
  
//   useEffect(() => {
//     var body = document.body;
//     var verticalBody = document.getElementById("verticalDiv");
//     if (!body.classList.contains("vertical-collapsed") && width >= 998) {
//       verticalBody.style.overflowY = "auto"; // Show vertical scrollbar
//     } else {
//       verticalBody.style.overflowY = "";
//     }
//   }, [width])
  
//   // Fetch user data on component mount
//   const fetchUserData = async () => {
//     try {
//       setIsLoading(true);
      
//       // First check localStorage for basic info
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       console.log("Auth User from localStorage:", authUser); // Debug log
      
//       if (authUser) {
//         // Get user ID from localStorage
//         const userId = authUser.id;
//         setUserId(userId);
        
//         // Try to fetch detailed user data from API
//         if (userId) {
//           try {
//             const data = await getSingleUser(userId);
//             if (data?.success && data?.result?.[0]) {
//               const userData = data.result[0];
//               console.log("User data from API:", userData); // Debug log
              
//               // Set user's actual name from API response
//               setUserName(userData.name || "");
//               setUserEmail(userData.email || "");
//               setUserMobile(userData.mobile || "");
              
//               // Get user type/role from API or localStorage
//               const role = userData.userType || 
//                          authUser.userType || 
//                          authUser.userTypeDto?.name || 
//                          "";
//               setUserRole(role);
              
//               // Get depot from API or localStorage
//               let depot = "";
//               if (userData.depot) {
//                 depot = userData.depot;
//               } else if (authUser.depot) {
//                 depot = authUser.depot;
//               } else if (authUser.tataUserDetailsDto?.depot) {
//                 depot = authUser.tataUserDetailsDto.depot;
//               } else if (authUser.userDetails?.depot) {
//                 depot = authUser.userDetails.depot;
//               }
//               setUserDepot(depot);
              
//               // Set profile image if available
//               if (userData.image || userData.profileImage) {
//                 setUserProfile(userData.image || userData.profileImage);
//               }
//             } else {
//               // Fallback to localStorage data if API fails
//               setUserName(authUser.name || authUser.username || "User");
//               setUserEmail(authUser.email || "");
//               setUserMobile(authUser.mobile || "");
//               setUserRole(authUser.userType || authUser.userTypeDto?.name || "");
              
//               // Get depot from localStorage
//               let depot = "";
//               if (authUser.depot) {
//                 depot = authUser.depot;
//               } else if (authUser.tataUserDetailsDto?.depot) {
//                 depot = authUser.tataUserDetailsDto.depot;
//               } else if (authUser.userDetails?.depot) {
//                 depot = authUser.userDetails.depot;
//               }
//               setUserDepot(depot);
              
//               setUserProfile(authUser.image || null);
//             }
//           } catch (error) {
//             console.error("Error fetching user data:", error);
//             // Fallback to localStorage data
//             setUserName(authUser.name || authUser.username || "User");
//             setUserEmail(authUser.email || "");
//             setUserMobile(authUser.mobile || "");
//             setUserRole(authUser.userType || authUser.userTypeDto?.name || "");
            
//             // Get depot from localStorage
//             let depot = "";
//             if (authUser.depot) {
//               depot = authUser.depot;
//             } else if (authUser.tataUserDetailsDto?.depot) {
//               depot = authUser.tataUserDetailsDto.depot;
//             } else if (authUser.userDetails?.depot) {
//               depot = authUser.userDetails.depot;
//             }
//             setUserDepot(depot);
            
//             setUserProfile(authUser.image || null);
//           }
//         } else {
//           // If no userId, use localStorage data only
//           setUserName(authUser.name || authUser.username || "User");
//           setUserEmail(authUser.email || "");
//           setUserMobile(authUser.mobile || "");
//           setUserRole(authUser.userType || authUser.userTypeDto?.name || "");
          
//           // Get depot from localStorage
//           let depot = "";
//           if (authUser.depot) {
//             depot = authUser.depot;
//           } else if (authUser.tataUserDetailsDto?.depot) {
//             depot = authUser.tataUserDetailsDto.depot;
//           } else if (authUser.userDetails?.depot) {
//             depot = authUser.userDetails.depot;
//           }
//           setUserDepot(depot);
          
//           setUserProfile(authUser.image || null);
//         }
        
//         // Get organization ID
//         setOrganizationId(authUser.organizationId);
//       }
//     } catch (error) {
//       console.error("Error in fetchUserData:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };
  
//   useEffect(() => {
//     fetchUserData();
//   }, []);

//   function toggleFullscreen() {
//     if (
//       !document.fullscreenElement &&
//       /* alternative standard method */ !document.mozFullScreenElement &&
//       !document.webkitFullscreenElement
//     ) {
//       // current working methods
//       if (document.documentElement.requestFullscreen) {
//         document.documentElement.requestFullscreen()
//       } else if (document.documentElement.mozRequestFullScreen) {
//         document.documentElement.mozRequestFullScreen()
//       } else if (document.documentElement.webkitRequestFullscreen) {
//         document.documentElement.webkitRequestFullscreen(
//           Element.ALLOW_KEYBOARD_INPUT
//         )
//       }
//     } else {
//       if (document.cancelFullScreen) {
//         document.cancelFullScreen()
//       } else if (document.mozCancelFullScreen) {
//         document.mozCancelFullScreen()
//       } else if (document.webkitCancelFullScreen) {
//         document.webkitCancelFullScreen()
//       }
//     }
//   }

//   function tToggle() {
//     if (logoHeight == 40) {
//       setLogoHeight(40)
//     }
//     else {
//       setLogoHeight(40)
//     }
//     var body = document.body;
//     body.classList.toggle("vertical-collpsed");
//     body.classList.toggle("sidebar-enable");

//     var blurDiv = document.getElementById("blur");
//     var bodyHeight = document.body.scrollHeight;

//     if (blurDiv && width <= 99) {
//       var isDivPageActive = blurDiv.classList.toggle(classes.divPage);
//       if (isDivPageActive) {
//         blurDiv.style.height = bodyHeight + "px"; // Set blur div height to body height
//       } else {
//         blurDiv.style.height = ""; // Reset height to its default value
//       }
//     }

//     var navBar = document.querySelector(".navbar-brand-box");
//     if (navBar && width <= 998) {
//       if (navBar.style.backgroundColor === "white") {
//         navBar.style.backgroundColor = ""; // Reset to default value
//       } else {
//         navBar.style.backgroundColor = "white";
//       }
//     }
//     if (navBar) {
//       if (navBar.style.padding === "") {
//         navBar.style.padding = "2px";
//       } else {
//         navBar.style.padding = "";
//       }
//     }
//   }

//   const toggleMenu = () => {
//     setMenu(!menu);
//   }

//   const logout = () => {
//     localStorage.removeItem("authUser");
//     localStorage.removeItem("accessToken");
//     localStorage.removeItem("refreshToken");
//     window.location.href = "/login";
//   }

//   const logo = JSON.parse(localStorage.getItem("authUser"))?.orgLogo;

//   // Format the username for display (first name only or split if full name)
//   const getDisplayName = () => {
//     if (!userName) return "User";
    
//     // If name contains spaces, take only the first name
//     if (userName.includes(" ")) {
//       return userName.split(" ")[0];
//     }
    
//     // If name is email, extract username part
//     if (userName.includes("@")) {
//       return userName.split("@")[0];
//     }
    
//     return userName;
//   };

//   return (
//     <React.Fragment>
//       <header id="page-topbar" style={{ zIndex: "10000" }}>
//         <div className="navbar-header" style={{ backgroundColor: "#024076" }}>
//           <div className="d-flex">
//             <div className="navbar-brand-box " style={{ backgroundColor: "#ceddf0", height: "80px" }}>
//               <Link to="/"
//                 className="logo logo-dark"
//               >
//                 <img
//                   src={organizationId === 2 ? tataLogo : lmsLogo}
//                   alt="Organization Logo"
//                   height="60"
//                   style={{ color: "white" }}
//                 />
//               </Link>

//               <Link to="/" className="logo logo-light" >
//                 {!logo ?
//                   <div className="">
//                     <img
//                       src={organizationId === 2 ? tataLogo : lmsLogo}
//                       alt=""
//                       height={organizationId === 2 ? 80 : logoHeight}
//                       style={{
//                         mixBlendMode: "multiply",
//                         background: "transparent",
//                         width:"100px",
//                       }}
//                     />
//                   </div>
//                   :
//                   <img src={IMAGE_FETCH + logo} alt="" height={logoHeight} />
//                 }
//               </Link>
//             </div>

//             <button
//               type="button"
//               onClick={() => {
//                 tToggle()
//               }}
//               className="btn btn-sm px-3 font-size-24 header-item waves-effect vertical-menu-btn"
//               id="vertical-menu-btn"
//             >
//               <i className="mdi mdi-menu" style={{ color: "white" }}></i>
//             </button>

//           </div>
//           <div className="d-flex" >
//             {/* User Profile Dropdown with Name */}
//             <Dropdown
//               isOpen={menu}
//               toggle={toggleMenu}
//               className="d-inline-block"
//               style={{ marginRight: "20px" }}
//             >
//               <DropdownToggle
//                 className="btn header-item waves-effect"
//                 id="page-header-user-dropdown"
//                 tag="button"
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   backgroundColor: "transparent",
//                   border: "none",
//                   padding: "8px 12px",
//                 }}
//               >
//                 {/* User Info Display */}
//                 <div style={{ 
//                   textAlign: "right", 
//                   marginRight: "12px",
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "flex-end"
//                 }}>
//                   <span
//                     style={{
//                       color: "white",
//                       fontWeight: "600",
//                       fontSize: "14px",
//                       maxWidth: "150px",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {isLoading ? "Loading..." : `Hi, ${getDisplayName()}`}
//                   </span>
//                   {userRole && !isLoading && (
//                     <span
//                       style={{
//                         color: "#d1e3ff",
//                         fontSize: "11px",
//                         fontWeight: "400",
//                         maxWidth: "150px",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         whiteSpace: "nowrap",
//                         marginTop: "2px"
//                       }}
//                     >
//                       {userRole}
//                       {userDepot && ` • ${userDepot}`}
//                     </span>
//                   )}
//                 </div>
                
//                 {/* Profile Image */}
//                 <img
//                   className="rounded-circle header-profile-user"
//                   src={userProfile ? (userProfile.startsWith("https") ? userProfile : IMAGE_FETCH + userProfile) : user1}
//                   alt="Header Avatar"
//                   style={{
//                     height: "40px",
//                     width: "40px",
//                     border: "2px solid white",
//                     objectFit: "cover"
//                   }}
//                 />
//               </DropdownToggle>
              
//               <DropdownMenu className="dropdown-menu-end" style={{ marginTop: "10px", minWidth: "220px" }}>
//                 {/* User Information Section */}
//                 <div style={{ padding: "12px 16px", borderBottom: "1px solid #f0f0f0" }}>
//                   {isLoading ? (
//                     <div style={{ textAlign: "center", color: "#666", fontSize: "14px" }}>
//                       Loading user data...
//                     </div>
//                   ) : (
//                     <>
//                       <div style={{ fontWeight: "600", fontSize: "14px", color: "#333" }}>
//                         {userName || "User"}
//                       </div>
//                       {userEmail && (
//                         <div style={{ fontSize: "12px", color: "#666", marginTop: "2px" }}>
//                           {userEmail}
//                         </div>
//                       )}
//                       {userMobile && (
//                         <div style={{ fontSize: "12px", color: "#666", marginTop: "2px" }}>
//                           {userMobile}
//                         </div>
//                       )}
//                       {userRole && (
//                         <div style={{ fontSize: "11px", color: "#888", marginTop: "2px", fontStyle: "italic" }}>
//                           {userRole}
//                         </div>
//                       )}
//                     </>
//                   )}
//                 </div>
                
//                 <DropdownItem tag="a" href="/profile" style={{ padding: "10px 16px" }}>
//                   <i className="bx bx-user font-size-16 align-middle me-2"></i>
//                   {props.t("My Profile")}
//                 </DropdownItem>
                
//                 {userDepot && !isLoading && (
//                   <DropdownItem style={{ padding: "8px 16px", fontSize: "12px", color: "#666", cursor: "default" }}>
//                     <i className="bx bx-map font-size-14 align-middle me-2"></i>
//                     Depot: <strong>{userDepot}</strong>
//                   </DropdownItem>
//                 )}
                
//                 <div className="dropdown-divider"></div>
//                 <DropdownItem className="text-danger" onClick={logout} style={{ padding: "10px 16px" }}>
//                   <i className="bx bx-power-off font-size-16 align-middle me-2 text-danger"></i>
//                   {props.t("Logout")}
//                 </DropdownItem>
//               </DropdownMenu>
//             </Dropdown>
            
//             {/* <NotificationDropdown /> */}
//           </div>
//         </div>
//       </header>
//     </React.Fragment>
//   )
// }

// Header.propTypes = {
//   changeSidebarType: PropTypes.func,
//   leftMenu: PropTypes.any,
//   leftSideBarType: PropTypes.any,
//   showRightSidebar: PropTypes.any,
//   showRightSidebarAction: PropTypes.func,
//   t: PropTypes.any,
//   toggleLeftmenu: PropTypes.func
// }

// const mapStatetoProps = state => {
//   const {
//     layoutType,
//     showRightSidebar,
//     leftMenu,
//     leftSideBarType,
//   } = state.Layout
//   return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
// }

// export default connect(mapStatetoProps, {
//   showRightSidebarAction,
//   toggleLeftmenu,
//   changeSidebarType,
// })(withTranslation()(Header))





import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useWindowSize } from "react-use";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withTranslation } from "react-i18next";

import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";

import { getSingleUser } from "helpers/user_helper";
import { IMAGE_FETCH } from "helpers/url_helper";

import lmsLogo from "../../assets/images/lmsLogo.png";
import tataLogo from "../../assets/images/Tata.png";
import user1 from "../../assets/images/profile_icon.png";

const Header = (props) => {
  const { width } = useWindowSize();

  const [menu, setMenu] = useState(false);
  const [organizationId, setOrganizationId] = useState(null);
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState("");
  const [userDepot, setUserDepot] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userMobile, setUserMobile] = useState("");
  const [userProfile, setUserProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  /* -------------------- FETCH USER -------------------- */
  useEffect(() => {
    const fetchUser = async () => {
      setIsLoading(true);
      const authUser = JSON.parse(localStorage.getItem("authUser"));

      if (!authUser) return setIsLoading(false);

      setOrganizationId(authUser.organizationId);

      try {
        const res = await getSingleUser(authUser.id);
        const u = res?.result?.[0] || authUser;

        setUserName(u.name || "User");
        setUserEmail(u.email || "");
        setUserMobile(u.mobile || "");
        setUserRole(u.userType || authUser.userTypeDto?.name || "");
        setUserDepot(
          u.depot ||
            authUser.depot ||
            authUser.tataUserDetailsDto?.depot ||
            ""
        );
        setUserProfile(u.image || null);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, []);

  /* -------------------- LOGO SIZE LOGIC -------------------- */
  const getLogoStyle = () => {
    if (organizationId === 1) {
      return { width: "100px", height: "80px" };
    }
    if (organizationId === 2) {
      return { width: "160px", height: "80px" };
    }
    return { width: "120px", height: "60px" };
  };

  const logoStyle = getLogoStyle();

  /* -------------------- HELPERS -------------------- */
  const toggleMenu = () => setMenu(!menu);

  const logout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const displayName = userName?.split(" ")[0] || "User";

  const orgLogo =
    JSON.parse(localStorage.getItem("authUser"))?.orgLogo || null;

  const fallbackLogo = organizationId === 2 ? tataLogo : lmsLogo;

  /* -------------------- TOGGLE SIDEBAR -------------------- */
  const toggleSidebar = () => {
    // Toggle the sidebar-enable class
    document.body.classList.toggle("sidebar-enable");
    
    // Get the sidebar element
    const sidebar = document.querySelector('.vertical-menu');
    
    if (sidebar) {
      if (document.body.classList.contains('sidebar-enable')) {
        // When sidebar is enabled, make it scrollable
        sidebar.style.overflowY = 'auto';
        sidebar.style.height = 'calc(100vh - 80px)'; // Full height minus header
        sidebar.style.position = 'fixed';
        sidebar.style.top = '80px';
        sidebar.style.bottom = '0';
      } else {
        // When sidebar is hidden, reset styles
        sidebar.style.overflowY = '';
        sidebar.style.height = '';
        sidebar.style.position = '';
        sidebar.style.top = '';
        sidebar.style.bottom = '';
      }
    }
  };

  /* -------------------- JSX -------------------- */
  return (
    <header id="page-topbar" style={{ 
      zIndex: 10000,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0
    }}>
      <div className="navbar-header" style={{ backgroundColor: "#024076" }}>
        <div className="d-flex">
          <div
            className="navbar-brand-box"
            style={{ backgroundColor: "#ceddf0", height: "80px" }}
          >
            <Link to="/" className="logo logo-light">
              <img
                src={orgLogo ? IMAGE_FETCH + orgLogo : fallbackLogo}
                alt="Logo"
                style={{
                  ...logoStyle,
                  objectFit: "contain",
                }}
              />
            </Link>
          </div>

          <button
            type="button"
            onClick={toggleSidebar}
            className="btn btn-sm px-3 font-size-24 header-item"
          >
            <i className="mdi mdi-menu" style={{ color: "white" }} />
          </button>
        </div>

        {/* -------- USER DROPDOWN -------- */}
        <Dropdown
          isOpen={menu}
          toggle={toggleMenu}
          className="d-inline-block"
          style={{ marginRight: 20 }}
        >
          <DropdownToggle
            tag="button"
            className="btn header-item"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div style={{ textAlign: "right", marginRight: 10 }}>
              <div style={{ color: "white", fontWeight: 600 }}>
                {isLoading ? "Loading..." : `Hi, ${displayName}`}
              </div>
              <div style={{ fontSize: 11, color: "#cfdfff" }}>
                {userRole} {userDepot && `• ${userDepot}`}
              </div>
            </div>

            <img
              src={
                userProfile
                  ? userProfile.startsWith("http")
                    ? userProfile
                    : IMAGE_FETCH + userProfile
                  : user1
              }
              alt="profile"
              className="rounded-circle"
              style={{
                height: 40,
                width: 40,
                border: "2px solid white",
                objectFit: "cover",
              }}
            />
          </DropdownToggle>

          <DropdownMenu end>
            <DropdownItem tag="a" href="/profile">
              <i className="bx bx-user me-2" />
              My Profile
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem className="text-danger" onClick={logout}>
              <i className="bx bx-power-off me-2 text-danger" />
              Logout
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>

      {/* Add CSS for scrollable sidebar */}
      <style>
        {`
          /* Make sidebar scrollable */
          .vertical-menu {
            transition: all 0.3s ease;
          }
          
          .sidebar-enable .vertical-menu {
            overflow-y: auto !important;
            height: calc(100vh - 80px) !important;
            position: fixed !important;
            top: 80px !important;
            bottom: 0 !important;
            left: 0 !important;
            z-index: 9999 !important;
            width: 250px !important;
          }
          
          /* Custom scrollbar for sidebar */
          .vertical-menu::-webkit-scrollbar {
            width: 6px;
          }
          
          .vertical-menu::-webkit-scrollbar-track {
            background: #f1f1f1;
          }
          
          .vertical-menu::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 3px;
          }
          
          .vertical-menu::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
          
          /* Ensure main content doesn't get hidden behind fixed header */
          .main-content {
            margin-top: 80px !important;
          }
          
          /* Adjust layout when sidebar is open */
          body.sidebar-enable .main-content {
            margin-left: 250px !important;
          }
          
          /* Responsive adjustments */
          @media (max-width: 768px) {
            .sidebar-enable .vertical-menu {
              width: 100% !important;
            }
            
            body.sidebar-enable .main-content {
              margin-left: 0 !important;
            }
          }
        `}
      </style>
    </header>
  );
};

/* -------------------- REDUX -------------------- */
Header.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = (state) => ({
  layoutType: state.Layout.layoutType,
});

export default connect(mapStateToProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
